/**
 * Days a team that pays by transfer has to settle an invoice (#742).
 *
 * This file is consumed by `@shaarp/ui`, to tell the manager the delay before
 * the invoice is issued. `@shaarp/api` cannot import a runtime value from this
 * package (its barrel re-exports a directory, which Node refuses to resolve
 * from the API's CommonJS build), so it keeps a mirrored copy,
 * `INVOICE_DAYS_UNTIL_DUE` in `api/src/common/helpers/invoice-collection.helper.ts`,
 * held to this one by its spec. Keep both in sync: the window must promise
 * the delay Stripe grants.
 */
export const INVOICE_DAYS_UNTIL_DUE = 14;
